var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEventListener, } from '@anton.bobrov/react-hooks';
import { vevet } from '@anton.bobrov/vevet-init';
import { useState } from 'react';
/**
 * Hook for hover detection (**non-mobile devices only**)
 */
export function useNonMobileHover(ref, props) {
    var _a = useState(false), isHovered = _a[0], setIsHovered = _a[1];
    useEventListener(__assign({ ref: ref, target: 'mouseenter', listener: function () { return setIsHovered(true); }, getIsDisabled: function () { return vevet.isMobile; } }, props));
    useEventListener(__assign({ ref: ref, target: 'mouseleave', listener: function () { return setIsHovered(false); }, getIsDisabled: function () { return vevet.isMobile; } }, props));
    return isHovered;
}
//# sourceMappingURL=useNonMobileHover.js.map